module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("News Feed")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.$root.permissions['news_feed create']) ? _c('div', {
    staticClass: "portlet box blue-hoki margin-top-20"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleCreateFeedPanel()
      }
    }
  }, [_c('div', {
    staticClass: "custom tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.createFeedCollapse, 'collapse': _vm.createFeedCollapse
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\t Create News Feed\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.createFeedCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createNewsFeed($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createFeedError.length),
      expression: "createFeedError.length"
    }],
    ref: "createFeedError",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearCreateFeedError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.createFeedError))])])]), _vm._v(" "), _c('div', {
    class: {
      'col-md-2': !_vm.imageMode.newMenu, 'col-md-12': _vm.imageMode.newMenu
    }
  }, [_c('resource-picker', {
    staticClass: "margin-top-15",
    attrs: {
      "imageButton": true,
      "imageUrl": _vm.newNewsFeed.image
    },
    on: {
      "open": function($event) {
        _vm.toggleImageMode('newMenu', true)
      },
      "close": function($event) {
        _vm.toggleImageMode('newMenu', false)
      },
      "selected": _vm.updateImage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageMode.newMenu),
      expression: "!imageMode.newMenu"
    }],
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNewsFeed.title),
      expression: "newNewsFeed.title"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newNewsFeed.title.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.newNewsFeed.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNewsFeed, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Title")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNewsFeed.short_description),
      expression: "newNewsFeed.short_description"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newNewsFeed.short_description.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newNewsFeed.short_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNewsFeed, "short_description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Short Description")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNewsFeed.external_url),
      expression: "newNewsFeed.external_url"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newNewsFeed.external_url.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_external_url"
    },
    domProps: {
      "value": (_vm.newNewsFeed.external_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNewsFeed, "external_url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Link")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageMode.newMenu),
      expression: "!imageMode.newMenu"
    }],
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNewsFeed.body),
      expression: "newNewsFeed.body"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newNewsFeed.body.length
    },
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.newNewsFeed.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNewsFeed, "body", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Body")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageMode.newMenu),
      expression: "!imageMode.newMenu"
    }],
    staticClass: "col-xs-12"
  }, [_vm._m(1, false, false)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "relative-block"
  }, [(_vm.newsFeed.length) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSortByOrder
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSort by\n\t\t\t\t\t\t\t"), _c('span', [(_vm.sortBy.order === 'ASC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortBy.order === 'DESC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ASC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "DESC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])], 1)], 1), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.totalResults,
      "activePage": _vm.activePage
    },
    on: {
      "pageResults": _vm.pageResultsUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.newsFeed.length) ? _c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "timeline"
  }, _vm._l((_vm.newsFeed), function(news, index) {
    return _c('div', {
      key: index,
      staticClass: "timeline-item"
    }, [_c('div', {
      staticClass: "timeline-badge"
    }, [(news.image.length) ? _c('img', {
      staticClass: "timeline-badge-userpic",
      attrs: {
        "src": news.image
      }
    }) : _vm._e(), _vm._v(" "), (!news.image.length) ? _c('img', {
      staticClass: "timeline-badge-userpic",
      attrs: {
        "src": require("../../../src/assets/img/app/image-placeholder.png")
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "timeline-body",
      attrs: {
        "id": 'news-' + news.id
      }
    }, [_c('div', {
      staticClass: "timeline-body-arrow"
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-body-head"
    }, [_c('div', {
      staticClass: "timeline-body-head-caption"
    }, [_c('a', {
      staticClass: "timeline-body-title font-blue-madison"
    }, [_vm._v(_vm._s(news.title))])]), _vm._v(" "), _c('div', {
      staticClass: "timeline-body-head-actions"
    }, [(_vm.$root.permissions['news_feed update']) ? _c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn blue btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editNewsFeed(news)
        }
      }
    }, [_vm._v(" Edit")])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['news_feed read'] && !_vm.$root.permissions['news_feed update']) ? _c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn blue btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editNewsFeed(news)
        }
      }
    }, [_vm._v(" View")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "timeline-body-content"
    }, [_c('h5', [_vm._v(_vm._s(news.formatted_date))]), _vm._v(" "), _c('span', {
      staticClass: "font-grey-cascade"
    }, [_vm._v(_vm._s(news.short_description))]), _vm._v(" "), _c('span', {
      staticClass: "font-grey-cascade"
    }, [_vm._v(_vm._s(news.external_url))])])])])
  }))]), _vm._v(" "), (!_vm.newsFeed.length && _vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]) : _c('div', [_c('no-results', {
    attrs: {
      "show": !_vm.newsFeed.length,
      "type": 'news feed'
    }
  })], 1), _vm._v(" "), (_vm.newsFeed.length && _vm.numPages > 1) ? _c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.showEditFeedModal) ? _c('edit-news-feed', {
    attrs: {
      "selectedFeedId": _vm.selectedFeedId
    },
    on: {
      "closeEditFeedModal": _vm.closeEditFeedModal,
      "updateNewsFeed": _vm.updateNewsFeed
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Create and manage the Application News Feed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o font-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold font-green uppercase"
  }, [_vm._v(" News Feed")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7885dc91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/NewsFeed.vue
// module id = 756
// module chunks = 0